module.exports = __webpack_public_path__ + "img/herb-oregano-190x100.2804d82d.jpg";